import axios from 'axios';

const API = axios.create({
  baseURL: '/api'
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// A token can stop being valid before it expires - a password change revokes
// every session issued earlier. Without this, the navbar would still show the
// user as logged in while every request quietly failed.
API.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const isLoginAttempt = error?.config?.url?.includes('/auth/login');

    if (status === 401 && !isLoginAttempt) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login') {
        window.location.replace('/login');
      }
    }
    return Promise.reject(error);
  }
);

export const auth = {
  register: (data) => API.post('/auth/register', data),
  login: (data) => API.post('/auth/login', data),
  getProfile: () => API.get('/auth/profile'),
  updateProfile: (data) => API.put('/auth/profile', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  getPublicProfile: (userId) => API.get(`/auth/profile/${userId}`),
  verifyEmail: (token) => API.post('/auth/verify-email', { token }),
  resendVerification: (email) => API.post('/auth/resend-verification', { email }),
  forgotPassword: (email) => API.post('/auth/forgot-password', { email }),
  resetPassword: (token, password) => API.post('/auth/reset-password', { token, password })
};

export const recipes = {
  getAll: (params) => API.get('/recipes', { params }),
  getById: (id) => API.get(`/recipes/${id}`),
  create: (data) => API.post('/recipes', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  update: (id, data) => API.put(`/recipes/${id}`, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  delete: (id) => API.delete(`/recipes/${id}`),
  approve: (id) => API.patch(`/recipes/${id}/approve`),
  toggleLike: (id) => API.post(`/recipes/${id}/like`),
  toggleMade: (id) => API.post(`/recipes/${id}/made`),
  getMyRecipes: () => API.get('/recipes/my-recipes'),
  getDrafts: () => API.get('/recipes/my-drafts'),
  publishDraft: (id) => API.post(`/recipes/${id}/publish`),
  toggleFavorite: (id) => API.post(`/recipes/${id}/favorite`),
  getFavorites: () => API.get('/recipes/favorites/my-favorites'),
  rateRecipe: (id, rating) => API.post(`/recipes/${id}/rate`, { rating }),
};


export const comments = {
  getAll: (recipeId) => API.get(`/comments/${recipeId}`),
  create: (recipeId, content) => API.post(`/comments/${recipeId}`, { content }),
  update: (commentId, content) => API.put(`/comments/${commentId}`, { content }),
  delete: (commentId) => API.delete(`/comments/${commentId}`)
};
export default API;
